import { createSimpleStore } from "@expert/state-utils";

interface BlockedChatState {
    /**
     * True while a voice contact is holding the agent non-routable in the chat build, so new chats aren't
     * being delivered (#6973). Set by the SDK's agent-state detector; drives the BlockedChatBanner. Not
     * persisted — it reflects the live block and is re-derived at SDK init.
     */
    isBlocked: boolean;
}

interface BlockedChatActions {
    setBlocked: (isBlocked: boolean) => void;
}

export type BlockedChatStore = BlockedChatState & BlockedChatActions;

export const useBlockedChatStore = createSimpleStore<BlockedChatStore>({
    devtools: {
        store: "blockedChat",
        name: "workspace/blocked-chat",
        isProd: import.meta.env.VITE_ENV_TYPE === "production",
    },
})((set) => ({
    isBlocked: false,
    setBlocked: (isBlocked: boolean) => set({ isBlocked }, false, "setBlocked"),
}));
